import {createContext} from 'react';

const DonationContext = createContext();
DonationContext.displayName = 'DonationContext';
export default DonationContext;
